import { defineQuery } from 'next-sanity'
import { imageFields, linkFields } from '../atoms'

export const careersLocationLinksBlockFields = `
  _id,
  _type,
  locationLinks[]{
    locationTitle,
    locationImage {
      ${imageFields}
    },
    "locationPageLink": locationPageLink{
      ${linkFields}
    }
  }
`

export const CAREERS_LOCATION_LINKS_BLOCK_QUERY = defineQuery(/* groq */ `
  *[_type == "careers-location-links-block"][0]{
    ${careersLocationLinksBlockFields}
  }
`)
